import { Box, CircularProgress, IconButton, TextField } from "@mui/material";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import InsertEmoji from "../../../../SVGs/InsertEmoji";
import SendBtn from "../../../../SVGs/SendBtn";
import { createNewCommentAction } from "../../../../store/actions/video/comments";

export default function CommentInput({ postId }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState();
  const [text, setText] = useState("");

  const createPost = useCallback(() => {
    setLoading(true);
    let allFiles = [];

    if (postId) {
      return createNewCommentAction({
        files: allFiles,
        text,
        postId,
        cb: (err) => {
          setLoading(false);
          if (!err) {
            setText("");
          }
        },
      })(dispatch);
    }
  }, [dispatch, postId, text]);
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "start",
        alignItems: "middle",
        gap: { xs: "0", sm: "1em" },
        padding: "2em 2em 2em 2em",
      }}
    >
      <TextField
        disabled={loading}
        value={text}
        onChange={(e) => setText(e?.target?.value)}
        placeholder="Write your comment..."
        sx={{
          width: { xs: "100%", sm: "50%" },
          borderRadius: "27px",
          backgroundColor: "white",
          p: 0.5,
        }}
        size="small"
        variant="standard"
        InputProps={{
          disableUnderline: true,
          endAdornment: (
            <IconButton
              size="small"
              sx={{
                fill: "#7a7a7a",
                transition: "0.5s all",
                "&:hover": {
                  backgroundColor: "transparent",
                  fill: "#25AAE1",
                },
              }}
            >
              <InsertEmoji />
            </IconButton>
          ),
        }}
      />
      <IconButton
        size="small"
        sx={{
          width: "40px",
          height: "40px",
          minHeight: "fit-content",
          minWidth: "fit-content",
          transition: "0.5s all",
          backgroundColor: "primary.main",
          stroke: "#000",
        }}
        disabled={loading}
        onClick={createPost}
      >
        {loading ? (
          <CircularProgress sx={{ height: 20 }} size={20} />
        ) : (
          <SendBtn />
        )}
      </IconButton>
    </Box>
  );
}
